import { useCallback, useEffect, useState } from "react";

import { fromCustomer } from "shared/analytics/useTrackProduct/mappers/analytics-customer.mapper";
import {
  trackProductAdded,
  trackProductClicked,
  trackProductRemoved,
  trackProductViewed,
} from "utils/analytics/analytics.utils";

import { fromItem } from "./mappers/rudderstack-product.mapper";
import { useTrackProductLazyQuery } from "./track-product.query.generated";

type TrackingFunction =
  | typeof trackProductViewed
  | typeof trackProductClicked
  | typeof trackProductAdded
  | typeof trackProductRemoved;

export const useTrackProduct = () => {
  const [getProduct, { data }] = useTrackProductLazyQuery({
    fetchPolicy: "network-only",
  });

  const [trackingFunction, setTrackingFunction] = useState<TrackingFunction>();

  useEffect(() => {
    if (data?.items && trackingFunction) {
      const products = data.items.map(fromItem);
      const customer = fromCustomer(data.customer);

      products.map((product) => trackingFunction(product, customer));

      setTrackingFunction(undefined);
    }
  }, [data, trackingFunction]);

  return {
    trackProductViewed: useCallback(
      (sku: string) => {
        setTrackingFunction(() => trackProductViewed);
        getProduct({ variables: { sku } });
      },
      [getProduct],
    ),

    trackProductClicked: useCallback(
      (sku: string) => {
        setTrackingFunction(() => trackProductClicked);
        getProduct({ variables: { sku } });
      },
      [getProduct],
    ),

    trackProductAdded: useCallback(
      (sku: string) => {
        setTrackingFunction(() => trackProductAdded);
        getProduct({ variables: { sku } });
      },
      [getProduct],
    ),

    trackProductRemoved: useCallback(
      (sku: string) => {
        setTrackingFunction(() => trackProductRemoved);
        getProduct({ variables: { sku } });
      },
      [getProduct],
    ),
  };
};
